/* ============================================================================
   HOSTED FLOW BETA — pemilih mode (Control Panel tab Flow, v3.9)
   ============================================================================
   Pelanggan LAYAK (langganan Lite LP aktif — disahkan server via /quota.eligible)
   pilih cara jalankan SATU run:
     · Hosted Flow Beta (lalai) → job ke PC ofis SESAAT (boleh tutup browser).
     · Run Flow Biasa           → extension Chrome sendiri (laluan lama).
   ⛔ Pilihan untuk satu RUN, BUKAN toggle per Product Card. Hanya card+set yang
      ditick + Submit masuk queue. Pelanggan TAK layak → komponen render null.
   ⛔ RUPA + mode simpan per-browser (utils/hostedBeta.js). Fail-closed bila backend tiada.
   Had: 3 card / 9 video sehari / 1 scene. Veo 3.1 Lite LP + workflow Guna gambar card.
   ========================================================================== */
import { useEffect, useState } from 'react';
import { useT } from '../i18n';
import { bacaKuotaHostedBeta, semakHealth } from '../services/centralWorkerService';

const pill = { display: 'inline-block', padding: '2px 10px', borderRadius: 999, fontSize: 12, fontWeight: 600, background: 'var(--s-ink-7, #eef)', color: 'var(--s-ink-1, #223)' };

function Pilihan({ aktif, tajuk, sub, onClick }) {
  return (
    <button type="button" onClick={onClick} aria-pressed={aktif}
      style={{ display: 'flex', gap: 10, alignItems: 'flex-start', textAlign: 'left', width: '100%',
        padding: '10px 12px', borderRadius: 10, cursor: 'pointer',
        border: `1px solid ${aktif ? 'var(--s-brand, #6a5af9)' : 'var(--s-line)'}`,
        background: aktif ? 'var(--s-brand-7, rgba(106,90,249,.06))' : 'var(--s-bg, transparent)' }}>
      <span style={{ marginTop: 2, width: 15, height: 15, borderRadius: '50%', flex: 'none',
        border: `2px solid ${aktif ? 'var(--s-brand, #6a5af9)' : 'var(--s-line-strong, #bbb)'}`,
        boxShadow: aktif ? 'inset 0 0 0 3px var(--s-brand, #6a5af9)' : 'none' }} />
      <span style={{ minWidth: 0 }}>
        <span style={{ display: 'block', fontSize: 13.5, fontWeight: 600, color: 'var(--s-ink, #223)' }}>{tajuk}</span>
        <span style={{ display: 'block', fontSize: 12, color: 'var(--s-ink-3, #778)' }}>{sub}</span>
      </span>
    </button>
  );
}

export default function HostedBetaSuisV39({ nilai, onUbah, onEligible, uid }) {
  const t = useT();
  const [kuota, setKuota] = useState(null);
  const [eligible, setEligible] = useState(null); // null = tengah semak
  const [sihat, setSihat] = useState(null);
  const mode = nilai?.mode === 'biasa' ? 'biasa' : 'hosted';

  useEffect(() => {
    let batal = false;
    semakHealth().then((h) => { if (!batal) setSihat(h); });
    const ambil = () => bacaKuotaHostedBeta()
      .then((q) => { if (batal) return; setKuota(q); setEligible(!!q.eligible); if (onEligible) onEligible(!!q.eligible); })
      .catch(() => { if (batal) return; setEligible(false); if (onEligible) onEligible(false); });
    ambil();
    const tmr = setInterval(ambil, 15000);
    return () => { batal = true; clearInterval(tmr); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid]);

  if (eligible !== true) return null; // belum sah / tak layak → tiada pilihan Hosted

  return (
    <div className="s-sect" style={{ padding: '0 0 16px', borderBottom: '1px solid var(--s-line)', marginBottom: 16 }}>
      <span className="s-lbl" style={{ marginBottom: 8, display: 'block' }}>{t('hosted.mode.title')}</span>
      <div style={{ display: 'grid', gap: 8 }}>
        <Pilihan aktif={mode === 'hosted'} tajuk={t('hosted.mode.hosted')} sub={t('hosted.mode.hostedSub')} onClick={() => onUbah({ mode: 'hosted' })} />
        <Pilihan aktif={mode === 'biasa'} tajuk={t('hosted.mode.biasa')} sub={t('hosted.mode.biasaSub')} onClick={() => onUbah({ mode: 'biasa' })} />
      </div>

      {mode === 'hosted' && (
        <div style={{ display: 'grid', gap: 8, marginTop: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            {kuota
              ? <span style={pill}>{t('hosted.quota', { remaining: kuota.remaining, cap: kuota.cap, cardsRemaining: kuota.cardsRemaining, cardCap: kuota.cardCap })}</span>
              : <span className="s-hint" style={{ margin: 0 }}>{sihat === false ? 'Backend unavailable' : '…'}</span>}
          </div>
          {sihat === false && <p className="s-hint" style={{ margin: 0, color: 'var(--s-danger, #c0392b)' }}>⚠ Central Worker backend not reachable — Submit disabled until it is running.</p>}
          <p className="s-hint" style={{ margin: 0 }}>{t('hosted.closeNote')}</p>
        </div>
      )}
    </div>
  );
}
